module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.7849/img/storefront-header-blobs.svg"